module.exports = __webpack_public_path__ + "static/img/service3.9ff348a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/service3.jpg
// module id = DCT9
// module chunks = 9